import { isProd, isTest } from 'lib/appConfig';

// will return true if not in prod, as the api will always return false unless you are in prod
export const getIsAgentConnected = (state) => {
  return isProd || isTest ? state.agentStatus.connected : true;
};
